import { Component, Input, OnInit, inject } from "@angular/core";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import {
  CollectionFilterConfig,
  FieldFilterPickerConfig,
  Store as BryntumStore
} from "@bryntum/core-thin";
import {
  ColumnConfig,
  DateColumnConfig,
  FilterConfig,
  NumberColumnConfig
} from "@bryntum/grid-thin";
import { Meeting } from "@app/models/rest/meeting";
import { MeetingStore } from "@app/services/store/meeting-store";
import { GridComponent } from "../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-meeting-table-viewer",
  templateUrl: "./meeting-table-viewer.component.html",
  styleUrls: ["./meeting-table-viewer.component.scss"],
  imports: [GridComponent, MatPaginator]
})
export class MeetingTableViewerComponent
  extends BaseDataTablePageDirective<Meeting>
  implements OnInit
{
  protected meetingStore: MeetingStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: (ColumnConfig | DateColumnConfig | NumberColumnConfig)[] = [
    {
      field: "description",
      text: "Description",
      flex: 1,
      editor: false
    },
    {
      field: "externalPropertyReference",
      text: "Property",
      flex: 1,
      editor: false
    },
    {
      field: "location.latitude",
      text: "Latitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      field: "location.longitude",
      text: "Longitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      type: "meetingJump",
      width: "120px",
      exportable: false,
      text: "Meeting Link"
    } as unknown as ColumnConfig
  ];
  fakeJobStore = new BryntumStore({
    fields: ["id", "name", "status"],
    data: [
      {
        id: 1,
        externalJobReference: "Job 1",
        externalProjectReference: "sample",
        status: "DRAFT",
        postCode: "BN1 1AA"
      },
      { id: 2, name: "Job 2", status: "RELEASED" },
      { id: 3, name: "Job 3", status: "CANCELLED" },
      { id: 4, name: "Job 4", status: "COMPLETED" }
    ]
  });

  // statusFilterCreated: boolean = false;
  filterConfig: FilterConfig = {
    pickerConfig: {
      showAddFilterButton: false,
      dateFormat: "DD/MM/YYYY",

      canDeleteFilter: (filter) => {
        return filter.property !== "status";
      },
      getFieldFilterPickerConfig: (
        collectionFilterConfig: CollectionFilterConfig
      ): Partial<FieldFilterPickerConfig> => {
        switch (collectionFilterConfig.property) {
          case "planningWindowEnd":
            return {
              dateFormat: "DD/MM/YYYY",
              getValueFieldConfig: (filter, fieldConfig) => {
                console.log(filter, fieldConfig);
                fieldConfig.type = "date";
                fieldConfig.format = "DD/MM/YYYY";
                return fieldConfig;
              },
              operators: this.dateOperators
            };
          case "postCode":
          case "externalPropertyReference":
          case "externalProjectReference":
          case "externalCaseReference":
          case "externalJobReference":
            let stringFieldResult: any = {
              store: this.fakeJobStore,
              operators: this.stringOperators
            };
            if (
              this.gridStore.filters.findItem(
                "property",
                collectionFilterConfig.property
              ) === null
            ) {
              stringFieldResult.filter = {
                id: `${collectionFilterConfig.property}-${collectionFilterConfig.operator}`,
                property: collectionFilterConfig.property,
                operator:
                  collectionFilterConfig.operator === "includes"
                    ? "*"
                    : collectionFilterConfig.operator,
                value: collectionFilterConfig.value
              };
            }
            return stringFieldResult;
          case "priority.description":
          case "zone.name":
          case "status":
            const fixedFieldResult: any = {
              operatorLocked: true,
              propertyLocked: true,
              store: this.fakeJobStore,
              operators: this.fixedSetOperators,
              getValueFieldConfig: (filter, fieldConfig) => {
                fieldConfig.createOnUnmatched = false;
                return fieldConfig;
              }
            };
            if (
              this.gridStore.filters.findItem(
                "property",
                collectionFilterConfig.property
              ) === null
            ) {
              fixedFieldResult.filter = {
                id: `${collectionFilterConfig.property}-isIncludedIn`,
                property: collectionFilterConfig.property,
                operator: "isIncludedIn",
                value: collectionFilterConfig.value,
                disabled: collectionFilterConfig.disabled
              };
            }
            return fixedFieldResult;
        }
        return {};
      }
    }
  };
  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const meetingStore = inject(MeetingStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      meetingStore,
      store,
      dialog,
      "Meeting",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.meetingStore = meetingStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  openMeeting(meeting: Meeting) {
    this.router.navigate(["/meetings", "detail", meeting.id]).then();
  }

  onEvent($event: any) {
    if ($event.type === "meetingjump") {
      this.openMeeting($event.record);
      return;
    }
    super.onEvent($event);
  }

  gridTotalChange($event: any) {
    console.log("total change");
    console.log($event);
  }
}
